import { Page } from "src/app/core/models/page";
import { SortOrder } from 'src/app/core/interface/sort-order';

export class AdvisingAbnormalTableAbnormalItemGetRequest extends Page {
  adNo: string;
  detailSeqNo: number | null;
  sortOrder: SortOrder | null;

  constructor() {
    super();
    this.adNo = '';
    this.detailSeqNo = null;
    this.sortOrder = null;
  }
}
